import { ActionTypes } from './types';

export function setUsers(value: User[]) {
  return {
    type: ActionTypes.SET_USERS,
    value
  }
}
